<pathPantalla></pathPantalla>

<div [hidden]="consulta">
    <!-- Filtros -->
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}} </h3>
                </header>
            </section>
        </div>
    </div>

        <div class="divisor8"></div>

        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12" style="padding: 0px">
                <section class="widget">
                    <h5>Configure la aplicación de evaluación 360 para alumnos de Preescolar y Primaria</h5>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                            <dropdownCustom [titulo]="'Periodo de evaluación'" valorName="periodoevaluacionid" 
                            displayValor="descripcion" propiedad="periodoevaluacionid" 
                            [opciones]="listaperiodoevaluacion" [(ngModel)]="periodoevaluacion"
                            (ngModelChange)="preescolaryprimaria($event)"></dropdownCustom>
                        </div>
                    </div>
                    <!-- tabla -->
                    <div>
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="dataTable"
                            [noDataText]="'Sin Datos'"
                            (onEditingStart)="logEvent($event)"
                            [showColumnHeaders]="true"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>
    
                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>
    
                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
    
                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxo-editing
                            mode="cell"
                            [allowUpdating]="true"
                            >
                        </dxo-editing>
                            <dxi-column
                                dataField="nivel"  [allowEditing]="false"
                                caption="Nivel">
                            </dxi-column>
                            <dxi-column
                                dataField="grado"  [allowEditing]="false"
                                caption="Grado">
                            </dxi-column>
                            <dxi-column
                            dataField="grupo"  [allowEditing]="false"
                            caption="Grupo">
                        </dxi-column>
                            <!-- <dxi-column [showEditorAlways]="true"
                                dataField="fechaaplicacion"
                                caption="Fecha de aplicación"
                                dataType="date"
                                [editorOptions]="{ min: minDate, max: maxDate}">
                            </dxi-column> -->
                            <dxi-column
                                dataField="url"  [allowEditing]="false"
                                caption="Rutas">
                            </dxi-column>
                            <dxi-column
                                [allowExporting]="false"
                                caption="Acciones"
                                cellTemplate="cellAcciones"
                                alignment="center"
                                [minWidth]="120">
    
                            </dxi-column>
                            <!-- Acciones -->
                            <div *dxTemplate="let cell of 'cellAcciones'">
                                <button class="btn boton botonXS"
                                (click)="Correo(cell.data)">
                                <span > {{'Enviar ruta por correo'}}</span>
                            </button>
                            </div>
    
                        </dx-data-grid>
    
                    </div>
                </section>
            </div>
        </div>
</div>

<colaboradorevaluacionmodal
    #colaborador
    (respuesta)="Guardar($event)"
    ></colaboradorevaluacionmodal>